import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import { toggleArray } from "~/services/helpers";
import { Form } from "react-bootstrap";
import PopupActions from '~/Components/PopupActions/PopupActions';
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import { ChevronRight } from "~/Components/Icons/Icons";
import { DebounceInput } from "react-debounce-input";
import Layout from "~/Admin/Layout/Layout";
import { toast } from 'react-toastify';

const AdminCommunication = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const types = {
        invitation: 'Guest invitation',
        accepted: 'RSVP Accepted',
        declined: 'RSVP Declined',
        new_code: 'Code Reminder',
        host: 'Host Invitation',
        pre_event: 'Pre Event',
        event_survey: 'Event Survey',
        reminder: 'Reminder'
    };

    const statuses = {
        success: 'Success',
        error: 'Errors',
        pending: 'Pending'
    };

    const [filter, setFilter] = useState({
        search: '',
        type: 0,
        status: 0,
    });

    const [selected, setSelected] = useState([]);

    const handleFilter = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        let filterData = { ...filter, [name]: value };

        setFilter(filterData);
    };

    const loadData = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/emails?' + new URLSearchParams(filter).toString() + '&page=' + page,)
            .then(res => setResponse(res.data));
    };

    const handleResend = () => {

        toast.promise(
            adminHttp.post('/events/' + event.id + '/emails/resend', { ids: selected }),
            {
                pending: 'Re-sending Email(s)...',
                success: {
                    render() {

                        setError(null);

                        if (selected.length === 1) {
                            setMessage('Email has been resent!');
                        }

                        if (selected.length > 1) {
                            setMessage('Emails have been resent!');
                        }
                        setSelected([]);
                        return 'Email(s) re-sent'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        setMessage('');
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    useEffect(loadData, [filter, event]);

    const handleSelectedChange = (id) => {
        setSelected(toggleArray(selected, id));
    };

    return (
        <Layout>
            <>
                <div className="email-log">
                    <div className="row">
                        <div className="col-8">
                            <h2>Email Log</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm bg-white reports-filter">
                                <div className="row pt-2 pb-2">
                                    <div className="col-2">
                                        <label className="mt-2 ml-4 text-muted">FILTER</label>
                                    </div>
                                    <div className="col-10">

                                        <div className="row">
                                            <div className="col-4">
                                                <DebounceInput
                                                    onChange={handleFilter}
                                                    value={filter.search}
                                                    name="search"
                                                    className="form-control mr-4"
                                                    placeholder="Search email/name" />
                                            </div>
                                            <div className="col-3">
                                                <select name="status"
                                                    defaultValue={filter.status}
                                                    onChange={e => handleFilter(e)}
                                                    className="form-control">

                                                    <option value={0}>Status</option>

                                                    {Object.keys(statuses).map(status => (
                                                        <option key={status} value={status}>{statuses[status]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-3">
                                                <select name="type"
                                                    defaultValue={filter.type}
                                                    onChange={e => handleFilter(e)}
                                                    className="form-control">

                                                    <option value={0}>Type</option>

                                                    {Object.keys(types).map(type => (
                                                        <option key={type} value={type}>{types[type]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card shadow-sm bg-white mt-3">
                                <div className="card-body">
                                    {message && (
                                        <div className="alert alert-success" role="alert">
                                            {message}
                                        </div>
                                    )}

                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error.message || "Error saving event!"}
                                        </div>
                                    )}

                                    <table className="table">

                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Language</th>
                                                <th scope="col">Sent On</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {response.data?.map((email) => (
                                                <tr key={email.id}>
                                                    <td scope="row">
                                                        <Form.Check
                                                            key={email.id}
                                                            inline
                                                            type="checkbox"
                                                            id={'email-' + email.id}
                                                            value={email.id}
                                                            checked={selected.indexOf(email.id) >= 0}
                                                            onClick={e => handleSelectedChange(email.id)}
                                                        />
                                                    </td>
                                                    <td>{types[email.type]}</td>
                                                    <td>{email.name}</td>
                                                    <td>{email.email}</td>
                                                    <td>{statuses[email.status]}</td>
                                                    <td>{email.language?.name || '-'}</td>
                                                    <td>
                                                        <Moment format="DD/MM/YYYY h:mm:ss a" date={email.sent_at} />
                                                    </td>
                                                    <td>
                                                        <Link to={`/communication/${email.id}`}>
                                                            <ChevronRight />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                    {response.per_page < response.total && (
                                        <Pagination
                                            activePage={response.current_page}
                                            itemsCountPerPage={response.per_page}
                                            totalItemsCount={response.total}
                                            pageRangeDisplayed={5}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            onChange={loadData}
                                        />
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {selected.length > 0 && (
                    <PopupActions>
                        <ConfirmedButton
                            confirmTitle={"ReSend Invitation"}
                            confirmText={`Are you sure you want to proceed? This cannot be undone.`}
                            onClick={handleResend}
                            className="btn btn-secondary btn-xs mr-3">
                            Resend Selected ({selected.length})
                        </ConfirmedButton>
                    </PopupActions>
                )}
            </>
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminCommunication);
